export default __webpack_public_path__ + "static/media/cafeina-bg-desktop.6b4efb75.jpg";